import React from "react";
import styles from "./style.module.scss";
import Layout from "../../components/Layout/authenticatedLayout";

import ReplayDataManager from "../../components/DataManagers/ReplayDataManager";
import ReplaySelector from "../../components/Replay/ReplaySelector";
import FullSessionView from "../../components/Replay/FullSessionView";
import ReplaySlider from "../../components/Replay/ReplaySlider";
import ReplayControls from "../../components/Replay/ReplayControls";
import ReplayRaceTrace from "../../components/Replay/ReplayRaceTrace";
import ImportsDataManager from "../../components/DataManagers/ImportsDataManager";

function ReplayPage() {
  return (
    <Layout title={"Replay"} showJaguarLogo={false}>
      <ReplayDataManager />
      <ImportsDataManager />
      <div className={styles.container}>
        <div className={styles.selectorContainer}>
          <div className={styles.row1}>
            <ReplaySelector />
            <FullSessionView />
          </div>
          <ReplayControls />
        </div>
        <ReplayRaceTrace />
        <div className={styles.sliderRow}>
          <ReplaySlider />
        </div>
      </div>
    </Layout>
  );
}

export default ReplayPage;
